import type {
  IPartnerInfo,
  IPartnerValidationApiResponse,
  ICreateRequestPayload,
  ICreateRequestResponse,
} from "@/types/partnerTypes";
import { apiService } from "@/services/apiService";

/**
 * Partner Service
 * Handles partner validation and incentive request creation via the real API.
 */

async function lookupPartner(partnerOneId: string): Promise<IPartnerInfo> {
  const instance = await apiService.getInstance();
  const response = await instance.get<IPartnerValidationApiResponse>(
    `/api/IncentiveRequests/validate/${encodeURIComponent(partnerOneId)}`,
  );

  const result = response.data;

  if (!result.isValidPartner) {
    throw new Error(`Partner ${partnerOneId} was not found.`);
  }

  return {
    partnerOneId: result.partnerOneId,
    partnerName: result.partnerName ?? result.partnerOneId,
    isEligible: result.isValidPDM,
    associatedPdms: result.associatedPdms ?? [],
  };
}

async function createRequest(payload: ICreateRequestPayload): Promise<ICreateRequestResponse> {
  const instance = await apiService.getInstance();
  const response = await instance.post<ICreateRequestResponse>("/api/IncentiveRequests", payload);
  return response.data;
}

export const partnerService = {
  lookupPartner,
  createRequest,
};
